


















































































import { ObjectFactory } from '@/config/objectFactory';
import { EventBus } from '@/main';
import { ToastEvent } from '@/types/event';
import { ApiRequest, CreateVehicleRequest, QueryRecordsRequest } from '@/types/request';
import { CommonUtils } from '@/util/commonUtils';
import { MedTransGoConstants } from '@/util/constants';
import { Component, Vue } from 'vue-property-decorator';
import { minLength, required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
// tslint:disable-next-line: no-var-requires
const VehicleMakes = require('../../config/vehicleMake.json');

@Component({
 mixins: [validationMixin],
    props: {
        transportId: String,
    },
    data() {
        return {
            make: '',
            model: '',
            color: '',
            year: '',
            licenseNumberPlate: '',
            vehicleNo: '',
            equippedForWheelchair: '',
            equippedForStretcher: '',
            isYearValid: true,
            };
        },
    validations: {
        make: {
            required,
        },
        model: {
            required,
        },
        color: {
            required,
        },
        year: {
            required,
            minLength: minLength(4),
            regex: (year) => /^(19|20)\d{2}$/.test(year),
        },
        licenseNumberPlate: {
            required,
        },
        equippedForWheelchair: {
            required,
        },
        equippedForStretcher: {
            required,
        },
    },
})

export default class AddVehicleModal extends Vue {
    private show = true;
    private maxDate = new Date();
    private makes = VehicleMakes;

    private async addVehicle() {
        const iHttpService = ObjectFactory.getHttpService();
        const addVehicleRequest: CreateVehicleRequest = {
            make: this.$data.make,
            model: this.$data.model,
            color: this.$data.color,
            year: this.$data.year,
            licenseNumberPlate: this.$data.licenseNumberPlate,
            vehicleNo: this.$data.vehicleNo,
            equippedForWheelchair: this.$data.equippedForWheelchair,
            equippedForStretcher: this.$data.equippedForStretcher,
            transporterId: this.$props.id,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_VEHICLE}/add`,
            data: addVehicleRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<CreateVehicleRequest>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_ADD_VEHICLE'),
                title: 'Success!',
                timeout: 2000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.$emit('success');
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }

     private async validateYear() {
        this.$data.year = this.$data.year.replace(/\D/g, '').slice(0, 4);
        const currentYear = new Date().getFullYear();
        // tslint:disable-next-line:radix
        const enteredYear = parseInt(this.$data.year);
        if (isNaN(enteredYear) || enteredYear < 2000 || enteredYear > currentYear) {
            this.$data.isYearValid = false;
        } else {
            this.$data.isYearValid = true;
        }
    }

    private async close() {
     this.$emit('close');
    }
}
